import { z } from 'zod';

const PositiveCentsSchema = z
  .string()
  .regex(/^[1-9]\d*$/, 'must be a positive integer string (cents)');

const CompetenceMonthSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'must be YYYY-MM');

export const SaveCollaboratorWageBodySchema = z.object({
  amountCents: PositiveCentsSchema,
  effectiveMonth: CompetenceMonthSchema,
});

export type SaveCollaboratorWageBody = z.infer<typeof SaveCollaboratorWageBodySchema>;

export const CollaboratorWagePresentSchema = z.object({
  present: z.literal(true),
  userId: z.uuid(),
  amountCents: PositiveCentsSchema,
  effectiveMonth: CompetenceMonthSchema,
});

export const CollaboratorWageAbsentSchema = z.object({
  present: z.literal(false),
  userId: z.uuid(),
});

export const CollaboratorWageResponseSchema = z.discriminatedUnion('present', [
  CollaboratorWagePresentSchema,
  CollaboratorWageAbsentSchema,
]);

export type CollaboratorWageResponse = z.infer<typeof CollaboratorWageResponseSchema>;
